(function () {
  // Cal.com's queued embed API lets the scheduler resize as the booking progresses.
  if (!window.Cal) {
    (function (C, A, L) {
      const queue = function (api, args) { api.q.push(args); };
      const document = C.document;
      C.Cal = C.Cal || function () {
        const cal = C.Cal;
        const args = arguments;
        if (!cal.loaded) {
          cal.ns = {};
          cal.q = cal.q || [];
          const script = document.createElement('script');
          script.src = A;
          script.async = true;
          document.head.appendChild(script);
          cal.loaded = true;
        }
        if (args[0] === L) {
          const api = function () { queue(api, arguments); };
          const namespace = args[1];
          api.q = api.q || [];
          if (typeof namespace === 'string') {
            cal.ns[namespace] = cal.ns[namespace] || api;
            queue(cal.ns[namespace], args);
            queue(cal, ['initNamespace', namespace]);
          } else {
            queue(cal, args);
          }
          return;
        }
        queue(cal, args);
      };
    })(window, 'https://app.cal.com/embed/embed.js', 'init');
  }

  function initialize(root) {
    root.querySelectorAll('[data-hp-showroom-calendar]').forEach(function (element) {
      if (element.dataset.initialized) return;
      element.dataset.initialized = 'true';
      const namespace = element.id;
      window.Cal('init', namespace, { origin: 'https://cal.com' });
      if (window.HpShowroomTracking) {
        window.HpShowroomTracking.attach(namespace, element.dataset.themeId);
      }
      window.Cal.ns[namespace]('inline', {
        elementOrSelector: '#' + element.id,
        calLink: element.dataset.calLink,
        config: { layout: 'month_view', theme: 'light' }
      });
      window.Cal.ns[namespace]('ui', {
        theme: 'light',
        styles: { branding: { brandColor: '#000000' } },
        hideEventTypeDetails: true,
        layout: 'month_view'
      });
    });
  }

  initialize(document);
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
